// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormReply } from '~/utils/interface/review';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      content: yup.string().trim().optional(),
    })
    .required();
};

export const defaultValuesForm: IFormReply = {
  content: EMPTY_STRING,
};
